export default "__VITE_ASSET__CkRlgxcf__"